
      import { ServiceFormPage } from '/src/features/service-form/service-form-page.ts';

      document.addEventListener('DOMContentLoaded', () => {
        new ServiceFormPage({
          formType: 'coverletter',
          formEl: 'coverLetterForm',
          repeatingGroups: [
            {
              containerId: 'rentalHistoryList',
              max: 3,
              min: 1,
              addLabel: '新增居住记录',
              removeLabel: '删除',
              fields: [
                { name: 'rentalAddress', type: 'text', label: '居住地址', placeholder: '请填写' },
                {
                  name: 'rentalType',
                  type: 'select',
                  label: '居住类型',
                  options: [
                    { value: '自有住房', label: '自有住房' },
                    { value: '学生公寓', label: '学生公寓（有合同）' },
                    { value: '房东直租', label: '房东直租（有合同）' },
                    { value: '中介租房', label: '中介租房（有合同）' },
                    { value: '其他', label: '其他（无合同）' },
                  ],
                },
                { name: 'rentalStart', type: 'month', label: '居住起始时间', span: 'half' },
                { name: 'rentalEnd', type: 'month', label: '居住结束时间', span: 'half' },
                { name: 'rentalNote', type: 'text', label: '补充说明' },
              ],
            },
          ],
          messages: {
            loading: '正在提交Cover Letter信息...',
            success: '提交成功！我们会尽快为您准备Cover Letter。',
          },
          clipboardExport: {
            title: 'Cover Letter信息',
            recipientEmail: 'easyaussie.info@gmail.com',
          },
        });
      });
    